import React from 'react';
import { Link } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import MarcasCarousel from './MarcasCarousel';
import './Hero.css';

const PUBLIC_URL = process.env.PUBLIC_URL || '';

const PROYECTOS_HERO = [
  { id: 1, title: 'CAMPAMENTOS TEMPORALES TBM Y PLANTA CARRUSEL', image: '1 CAMPAMENTOS completo.svg' },
  { id: 2, title: 'CASO DE ÉXITO CON SIEMENS & MPSA', image: '2 CASO DE EXITO CON SIEMENS MPSA.svg' },
  { id: 3, title: 'PLANTA DE REBOMBEO DE AGUA RESIDUAL', image: '3 PLANTA DE REBOMBEO DE AGUA RESIDUAL.svg' },
];

const Hero = () => {
  // Safari/iOS: use PUBLIC_URL + encoded filename so background loads on all browsers
  const backgroundUrl = `${PUBLIC_URL}/images/${encodeURIComponent('Rectangle 32.png')}`;
  const backgroundStyle = {
    backgroundImage: `url("${backgroundUrl}")`,
    backgroundSize: 'cover',
    backgroundPosition: 'top center',
    backgroundRepeat: 'no-repeat',
  };

  return (
    <div className="hero-container" style={backgroundStyle}>
      <Header />

      <main className="hero-main">
        <img 
          src={`${PUBLIC_URL}/images/Solectric_main.svg`}
          alt="Solectric Main" 
          className="hero-main-image"
        />
        <h1 className="hero-text">
          "Energía que transforma. Ingeniería que impulsa"
        </h1>
        <Link to="/nosotros" className="sobre-button">
          Sobre Soletric
        </Link>
      </main>

      <footer className="hero-footer">
        <p className="footer-text">
          INGENIERÍA DE VALOR, SUMINISTRO ESPECIALIZADO Y EFICIENCIA ENERGÉTICA EN <br /> INFRAESTRUCTURA, ENERGÍA Y CLIMATIZACIÓN.
        </p>
      </footer>

      <section className="quienes-somos-section">
        <div className="quienes-somos-container">
          <div className="quienes-somos-left">
            <h2 className="quienes-somos-title">¿QUIÉNES SOMOS?</h2>
            <div className="quienes-somos-content">
              <p className="quienes-somos-text">
                Somos una empresa panameña especializada en <strong>soluciones eléctricas integrales</strong>, desde el diseño y la ingeniería hasta el suministro, instalación y puesta en marcha.
              </p>
              <p className="quienes-somos-text">
                Trabajamos con <strong>equipos certificados</strong> y <strong>marcas líderes como Siemens, Stulz, Centiel, LS Cable & System, Disano, nVent e INATRA</strong>. Con ello garantizamos rendimiento, seguridad y cumplimiento normativo en proyectos industriales, comerciales y públicos.
              </p>
              <p className="quienes-somos-text">
                Nuestra experiencia combina <strong>conocimiento técnico, asesoría especializada y acompañamiento permanente</strong> para asegurar sistemas eléctricos eficientes, escalables y sostenibles.
              </p>
              <div className="experience-counter">
                <span className="experience-number">+20</span>
                <span className="experience-text">Años de experiencia en <br /> soluciones eléctricas e <br /> infraestructura</span>
                <Link to="/nosotros" className="historia-button">
                  Ver historia completa
                </Link>
              </div>
            </div>
          </div>
          <div className="quienes-somos-right">
            <div className="feature-box">
              <h3 className="feature-box-title">EXPERIENCIA COMPROBADA</h3>
              <p className="feature-box-text">Participación en proyectos nacionales de infraestructura y alta tecnología.</p>
            </div>
            <div className="feature-box">
              <h3 className="feature-box-title">SOPORTE TÉCNICO CERTIFICADO</h3>
              <p className="feature-box-text">Acompañamiento en puesta en marcha, mantenimiento y postventa.</p>
            </div>
            <div className="feature-box">
              <h3 className="feature-box-title">CALIDAD Y EFICIENCIA ENERGÉTICA</h3>
              <p className="feature-box-text">Equipos respaldados y aprobados bajo estándares internacionales.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="svg-section">
        <div className="svg-section-container">
          <img 
            src={`${PUBLIC_URL}/images/${encodeURIComponent('QUE HACEMOS.svg')}?v=2`}
            alt="Qué Hacemos" 
            className="que-hacemos-svg"
          />
        </div>
      </section>

      <section className="especialidades-section">
        <div className="especialidades-container">
          <h2 className="especialidades-title">Especialidades técnicas</h2>
          <p className="especialidades-description">
            Nuestra experiencia se traduce en soluciones técnicas confiables y escalables, diseñadas para responder a los retos reales de cada proyecto, desde la ingeniería eléctrica hasta la integración de tecnologías sostenibles.
          </p>
          <div className="especialidades-svg-container">
            <img 
              src={`${PUBLIC_URL}/images/ESPECIALIDADES.svg`}
              alt="Especialidades" 
              className="especialidades-svg"
            />
          </div>
        </div>
      </section>

      <section className="productos-section">
        <div className="productos-container">
          <h2 className="productos-title">Productos y soluciones clave</h2>
          <p className="productos-subtitle">Soluciones confiables que integran tecnología, eficiencia y cumplimiento normativo</p>
          <p className="productos-description">
            En Soletric seleccionamos, diseñamos e implementamos productos eléctricos de alto desempeño que responden a las exigencias técnicas de cada proyecto, garantizando seguridad, continuidad operativa y escalabilidad a largo plazo.
          </p>
          <div className="productos-svg-container">
            <img 
              src={`${PUBLIC_URL}/images/PRODUCTOS.svg`}
              alt="Productos y soluciones clave" 
              className="productos-svg"
            />
          </div>
          <Link to="/proyectos" className="productos-button">
            Ver portafolio
          </Link>
        </div>
      </section>

      <section className="proyectos-section">
        <div className="proyectos-container">
          <h2 className="proyectos-title">Soluciones en Acción</h2>
          <p className="proyectos-subtitle">INGENIERÍA QUE SE TRADUCE EN IMPACTO REAL.</p>
          <p className="proyectos-description">
            Cada proyecto representa un reto técnico distinto y una oportunidad para aportar soluciones eléctricas confiables que impulsan el desarrollo, la eficiencia energética y la infraestructura de la región.
          </p>
          <div className="proyectos-svg-container">
            <div className="proyectos-hero-grid">
              {PROYECTOS_HERO.map((proyecto) => (
                <div key={proyecto.id} className="proyectos-hero-card">
                  <img
                    src={`${PUBLIC_URL}/images/Proyectos/${encodeURIComponent(proyecto.image)}`}
                    alt={proyecto.title}
                    className="proyectos-hero-thumb"
                  />
                </div>
              ))}
            </div>
          </div>
          <Link to="/proyectos" className="proyectos-button">
            Explorar proyectos
          </Link>
        </div>
      </section>

      <section className="presencia-section">
        <div className="presencia-container">
          <h2 className="presencia-title">Presencia regional</h2>
          <p className="presencia-subtitle">OPERACIÓN Y EXPERIENCIA TÉCNICA EN DISTINTOS PAÍSES DE LA REGIÓN.</p>
          <p className="presencia-description">
            Cada proyecto representa un reto técnico distinto y una oportunidad para aportar soluciones eléctricas confiables que impulsan el desarrollo, la eficiencia energética y la infraestructura de la región.
          </p>
          <div className="presencia-svg-container">
            <img 
              src={`${PUBLIC_URL}/images/${encodeURIComponent('PRESENCIA REGIONAL.svg')}`}
              alt="Presencia regional" 
              className="presencia-svg"
            />
          </div>
        </div>
      </section>

      <section className="marcas-section">
        <div className="marcas-container">
          <h2 className="marcas-title">PRODUCTOS Y MARCAS</h2>
          <p className="marcas-subtitle">EQUIPOS CERTIFICADOS Y MARCAS LÍDERES</p>
          <p className="marcas-description">
          Trabajamos con marcas líderes a nivel internacional que garantizan confiabilidad, cumplimiento normativo y alto desempeño en cada solución implementada. Cada proyecto es más seguro, eficiente y sostenible gracias a nuestras marcas aliadas.
          </p>
          
          <div className="marcas-lines-up">
            <img 
              src={`${PUBLIC_URL}/images/Lines_up.svg`}
              alt="Lines Up" 
              className="lines-svg"
            />
          </div>

          <MarcasCarousel />

          <div className="marcas-lines-down">
            <img 
              src={`${PUBLIC_URL}/images/Lines_down.svg`}
              alt="Lines Down" 
              className="lines-svg"
            />
          </div>
        </div>
      </section>

      <section className="socios-section">
        <div className="socios-container">
          <div className="socios-frame">
            <div className="socios-content">
              <h2 className="socios-title">SOCIOS COMERCIALES</h2>
              <p className="socios-subtitle">CONOCIMIENTO QUE SE COMPLEMENTA, SOLUCIONES QUE SE POTENCIAN</p>
              <p className="socios-description">
                Construimos relaciones con empresas que comparten nuestro compromiso con la innovación, la eficiencia energética y el crecimiento sostenible de Panamá y la región. Mediante estas alianzas, podemos integrar tecnologías líderes, optimizar procesos y garantizar resultados seguros para proyectos industriales, comerciales, residenciales y de infraestructura pública.
              </p>
              <div className="socios-cards">
                <div className="socio-card">
                  <img 
                    src={`${PUBLIC_URL}/images/Marcas63/Alpa.svg`}
                    alt="Alpha Electric" 
                    className="socio-card-frame"
                  />
                </div>
                <div className="socio-card">
                  <img 
                    src={`${PUBLIC_URL}/images/Marcas63/Aldisa.svg`}
                    alt="Aldisa" 
                    className="socio-card-frame"
                  />
                </div>
                <div className="socio-card">
                  <img 
                    src={`${PUBLIC_URL}/images/Marcas63/VGM.svg`}
                    alt="VGMobility" 
                    className="socio-card-frame"
                  />
                </div>
              </div>
              <p className="socios-footer">
                NUESTRAS SOLUCIONES EXISTEN GRACIAS A UN ECOSISTEMA TÉCNICO QUE UNE EXPERIENCIA, RECURSOS Y VISIÓN.
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Hero;

